import { Box, Chip, Typography } from '@mui/material';
import { IconCalendarStats } from "@tabler/icons-react";
import { useTheme } from '@emotion/react';
import { useSelector } from 'react-redux';

const ContractDate = () => {
    const theme = useTheme();
    /**
 * anchorRef is used on different componets and specifying one type leads to other components throwing an error
 * */
    // const anchorRef = useRef(null);

    const { loginState, loginUserInfo } = useSelector(state => state.auth);
    const { companyMenuItems, selectCompanyNo, contractDate } = useSelector(state => state.header);

    const LabelComponent = () => {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ marginRight: '0.5rem' }}>계약만료일자:</Typography>
                <Typography sx={{ marginRight: '0.5rem' }}>{contractDate || '계약정보없음'}</Typography>
            </Box>
        )
    }

    return (

        <Chip
            sx={{
                height: '48px',
                alignItems: 'center',
                borderRadius: '27px',
                transition: 'all .2s ease-in-out',
                borderColor: theme.palette.primary.light,
                backgroundColor: theme.palette.primary.light,
                '&[aria-controls="menu-list-grow"], &:hover': {
                    borderColor: theme.palette.primary.main,
                    background: `${theme.palette.primary.main}!important`,
                    color: theme.palette.primary.light,
                    '& svg': {
                        stroke: theme.palette.primary.light
                    }
                },
                '& .MuiChip-label': {
                    lineHeight: 0
                }
            }}
            icon={<IconCalendarStats sx={{ marginRight: '0.5rem' }} />}
            label={<LabelComponent />}
            variant="outlined"
            color="secondary"
        />
    );
};

export default ContractDate;
